<template lang="pug">
  section
    .hero.is-light
      .hero-body
        h1.title.is-5
          span.icon
            i.fas.fa-receipt.fa-sm.fa-fw
          span
            | 書籍毎に配本する

    section.section
      .scroll-table
        b-table(
            narrowed
            hoverable
            striped
            icon-pack="fa"
            :data="data"
            :loading="loading"
            @click="onClick"
            class="pointable"
            :default-sort="['product_code', 'desc']"
            )
          template(slot-scope="props")
            b-table-column(field="product_code" label="商品コード" width="200" sortable)
              | {{ props.row.product_code }}
            b-table-column(field="isbn" label="書籍名：ISBN" width="400")
              b-tag(type="is-info" class="shinkan-tag" v-show="showStatus(props.row.book_stock_status)") {{ props.row.book_stock_status }}
              | {{ bookName(props.row.isbn) }}
            b-table-column(field="book_released_on" label="発売日" width="100")
              | {{ bookReleasedOn(props.row.isbn) }}
            b-table-column(field="book_selling_price" label="価格" width="100")
              | {{ bookSellingPrice(props.row.isbn) }}
            b-table-column(field="book_selling_price" label="文響社在庫数" width="100")
              | {{ null }}
            b-table-column(field="remaining_order_number" label="注文残件数" width="100")
              | {{ props.row.remaining_order_number }}

</template>

<script>

export default {
  name: "books-table",
  data() {
    return {
      data: [],
      total: 0,
      loading: false,
      sortField: 'vote_count',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 25,
      isComponentModalActive: false,
      formProps: {
        shop_code_cont: '',
        name_cont: '',
        group_code_cont: '',
        telephone_cont: '',
        prefecture_cont: '',
        s: ''
      },
      default_params: null,
    }
  },
  computed: {
    books(){  return this.$store.getters['Books/records'] },
    deliver_types(){  return this.$store.getters['DeliverTypes/records'] },
    users(){ return this.$store.getters['Users/records'] },
  },
  methods: {
    openNew(){
    },
    /*
     * Load async data
     */
    onClick(row){
        window.location.href = `/users/books/${this.getBook(row.isbn).id}/multiple_manipulated_orders/new`
    },
    bookName(value){
      let a = this.getBook(value)
      return a != null ? `${a.name}: ${a.isbn}` : ''
    },
    bookReleasedOn(value){
      let a = this.getBook(value)
      return a != null ? `${a.released_on}` : ''
    },
    bookSellingPrice(value){
      let a = this.getBook(value)
      return a != null ? `${a.selling_price}` : ''
    },
    getBook(value){
      if (!value) return null
      let a = this.books.filter(book => book.isbn == value)
      return a.length > 0 ? a[0] : null
    },
    deliverTypeName(id){
      if (!id) return ''
      let tmp = this.deliver_types
          .filter(type => type.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    userName(id){
      if (!id) return ''
      let tmp = this.users
          .filter(user => user.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    showStatus(book_stock_status) {
      return (book_stock_status == '在庫あり') ? false : true
    },
    loadAsyncData() {
      this.loading = true
      this.$http.get(`/api/v1/accepting_order_items/books`)
          .then(({data}) => {
            this.data = []
            data.books.forEach((item) => {
              item.product_code = Number(item.product_code)
              this.data.push(item)
            })
            this.loading = false
          })
          .catch((error) => {
            this.data = []
            this.total = 0
            this.loading = false
            throw error
          })
    },
  },
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate(value, length) {
      return value.length > length
          ? value.substr(0, length) + '...'
          : value
    }
  },
  created(){
    this.default_params = '?' + [
      `page=${this.page}`,
      Object.keys(this.formProps).map((key) => {
        return `q[${key}]=${this.formProps[key]}`
      }).join('&')
    ].join('&')

    this.$store.dispatch('Books/fetch', 'books')
    this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
    this.$store.dispatch('Users/fetch', 'users')
  },
  mounted() {

    this.loadAsyncData()
  }
}

</script>
